import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-preferences',
  templateUrl: './account-preferences.component.html',
  styleUrls: ['./account-preferences.component.css']
})
export class AccountPreferencesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
